
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const CustomTooltip = withStyles((_) => ({
  tooltip: {
    fontSize: '0.875rem',
    padding: '4px 8px',
  },
}))(({ children, title, placement = "bottom", PopperProps, ...otherProps }) => (
  <Tooltip
    title={title}
    placement={placement}
    PopperProps={{
      style: { zIndex: 10000 },
      ...PopperProps
    }}
    {...otherProps}
  >
    {children}
  </Tooltip>
));

export default CustomTooltip;